var _circle, _circle2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 37.042,
    r: 36.125,
    fill: "#BAD980",
    fillOpacity: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.9997,
    cy: 37.0417,
    r: 28.028,
    fill: "#8DC63F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3602 26.8533C50.4686 26.9798 50.5546 27.1302 50.6133 27.2957C50.672 27.4611 50.7022 27.6386 50.7022 27.8177C50.7022 27.9969 50.672 28.1743 50.6133 28.3398C50.5546 28.5053 50.4686 28.6556 50.3602 28.7821L34.0601 47.8525C33.9519 47.9794 33.8234 48.08 33.682 48.1487C33.5405 48.2173 33.3889 48.2527 33.2357 48.2527C33.0826 48.2527 32.931 48.2173 32.7895 48.1487C32.6481 48.08 32.5196 47.9794 32.4114 47.8525L24.2614 38.3173C24.0427 38.0615 23.9199 37.7146 23.9199 37.3529C23.9199 36.9912 24.0427 36.6443 24.2614 36.3885C24.48 36.1327 24.7765 35.989 25.0857 35.989C25.3949 35.989 25.6914 36.1327 25.91 36.3885L33.2357 44.962L48.7116 26.8533C48.8197 26.7265 48.9482 26.6258 49.0896 26.5571C49.2311 26.4885 49.3827 26.4531 49.5359 26.4531C49.689 26.4531 49.8407 26.4885 49.9821 26.5571C50.1236 26.6258 50.252 26.7265 50.3602 26.8533Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.82565256a7753bff3c58547cf8a11e06.svg";
export { ForwardRef as ReactComponent };